// v3.9.0 — Carte note livreur + pourboire, rendue sous le message "livrée" du chat.
import { useState } from "react";

const TIPS = [
  { v: 0, label: "Sans" },
  { v: 200, label: "200 F" },
  { v: 500, label: "500 F" },
  { v: 1000, label: "1 000 F" },
];

export const CourierRatingCard = ({ orderRef, courierName, apiBase }) => {
  const storageKey = `aya_rating_${orderRef}`;
  const [saved, setSaved] = useState(() => {
    try { return JSON.parse(localStorage.getItem(storageKey) || "null"); } catch (_) { return null; }
  });
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [tip, setTip] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (busy || stars < 1) return;
    setBusy(true); setError(null);
    try {
      const r = await fetch(`${apiBase}/v3/delivery/orders/${orderRef}/rate`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("civ_user_token") || ""}` },
        body: JSON.stringify({ stars, tip_fcfa: tip }),
      });
      const d = await r.json();
      if (r.ok && d.ok) {
        const rec = d.rating || { stars, tip_fcfa: tip };
        localStorage.setItem(storageKey, JSON.stringify(rec));
        setSaved(rec);
      } else if (r.status === 402) {
        setError("Solde insuffisant pour le pourboire — réessaie sans pourboire.");
      } else {
        setError(d.error === "order_not_delivered" ? "Course pas encore livrée." : "Impossible d'enregistrer la note.");
      }
    } catch (_) { setError("Erreur réseau."); }
    finally { setBusy(false); }
  };

  if (saved) {
    return (
      <div data-testid={`courier-rating-done-${orderRef}`} style={{ ...cardStyle, textAlign: "center" }}>
        <div style={{ fontSize: 18, letterSpacing: 2 }}>{"★".repeat(saved.stars)}<span style={{ opacity: 0.25 }}>{"★".repeat(5 - saved.stars)}</span></div>
        <div style={{ fontSize: 12.5, marginTop: 4, color: "var(--aya-rating-txt, #16a34a)", fontWeight: 700 }}>
          Merci pour ta note{saved.tip_fcfa > 0 ? ` et les ${Number(saved.tip_fcfa).toLocaleString("fr-FR")} F de pourboire 💚` : " 💚"}
        </div>
        {courierName && <div style={{ fontSize: 11, opacity: 0.6, marginTop: 2 }}>{courierName} appréciera !</div>}
      </div>
    );
  }

  return (
    <div data-testid={`courier-rating-card-${orderRef}`} style={cardStyle}>
      <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 0.4 }}>
        Note {courierName ? <span style={{ color: "#059669" }}>{courierName}</span> : "ton livreur"}
      </div>
      <div style={{ display: "flex", gap: 6, marginTop: 8 }} data-testid={`courier-rating-stars-${orderRef}`}>
        {[1, 2, 3, 4, 5].map((s) => (
          <button
            key={s}
            type="button"
            data-testid={`courier-rating-star-${s}-${orderRef}`}
            onClick={() => setStars(s)}
            onMouseEnter={() => setHover(s)}
            onMouseLeave={() => setHover(0)}
            style={{
              background: "none", border: "none", cursor: "pointer", padding: 2,
              fontSize: 26, lineHeight: 1,
              color: s <= (hover || stars) ? "#F59E0B" : "rgba(128,128,128,0.35)",
              transform: s <= (hover || stars) ? "scale(1.12)" : "scale(1)",
              transition: "color 120ms ease, transform 120ms ease",
              filter: s <= (hover || stars) ? "drop-shadow(0 0 6px rgba(245,158,11,0.5))" : "none",
            }}
          >★</button>
        ))}
      </div>
      {stars > 0 && (
        <>
          <div style={{ fontSize: 11, opacity: 0.65, marginTop: 10 }}>Un pourboire pour {courierName || "le livreur"} ?</div>
          <div style={{ display: "flex", gap: 6, marginTop: 6, flexWrap: "wrap" }}>
            {TIPS.map((t) => (
              <button
                key={t.v}
                type="button"
                data-testid={`courier-tip-${t.v}-${orderRef}`}
                onClick={() => setTip(t.v)}
                style={{
                  padding: "7px 13px", borderRadius: 999, fontSize: 11.5, fontWeight: 800, cursor: "pointer",
                  border: tip === t.v ? "1.5px solid #059669" : "1px solid rgba(128,128,128,0.3)",
                  background: tip === t.v ? "rgba(5,150,105,0.12)" : "transparent",
                  color: tip === t.v ? "#059669" : "inherit",
                  transition: "border-color 120ms ease, background 120ms ease",
                }}
              >{t.v === 0 ? t.label : `💚 ${t.label}`}</button>
            ))}
          </div>
          <button
            type="button"
            data-testid={`courier-rating-submit-${orderRef}`}
            onClick={submit}
            disabled={busy}
            style={{
              marginTop: 12, width: "100%", padding: "10px 16px", borderRadius: 999,
              border: "none", cursor: "pointer", fontWeight: 900, fontSize: 13,
              background: "linear-gradient(135deg, #10B981, #059669)", color: "#fff",
              opacity: busy ? 0.6 : 1, boxShadow: "0 4px 14px rgba(16,185,129,0.3)",
            }}
          >{busy ? "Envoi…" : tip > 0 ? `Envoyer ★${stars} + ${tip.toLocaleString("fr-FR")} F` : `Envoyer ★${stars}`}</button>
        </>
      )}
      {error && <div data-testid={`courier-rating-error-${orderRef}`} style={{ fontSize: 11.5, color: "#DC2626", marginTop: 8 }}>{error}</div>}
    </div>
  );
};

const cardStyle = {
  marginTop: 10,
  padding: "14px 16px",
  borderRadius: 14,
  border: "1px solid rgba(5,150,105,0.35)",
  background: "rgba(5,150,105,0.06)",
};

export default CourierRatingCard;
